/** 階層パスの区切り文字（例: "01:総務費 / 02:企画費"） */
export const HIERARCHY_SEPARATOR = ' / ';

/** パンくず形式の区切り文字（例: "款 > 項 > 目"） */
export const BREADCRUMB_SEPARATOR = ' > ';

/** コードと名称の区切り文字（例: "01 : 総務費"） */
export const CODE_NAME_SEPARATOR = ' : ';
